import React from "react";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import { Box, Button } from "@mui/material";
import { useKeyboard } from "../../../hooks/KeyboardContext";

const Numpad = () => {
  const { visible, layoutName, keyboardRef, onKeyboardChange, onKeyPress, closeKeyboard } =
    useKeyboard();

  if (!visible) return null;

  return (
    // Docked at the bottom of the (flex-column) content area. Because it's an in-flow
    // sibling of the scrollable content — not a fixed overlay — it takes up space and
    // pushes the whole view upward instead of covering it.
    <Box
      sx={{
        flexShrink: 0,
        width: "100%",
        borderTop: 1,
        borderColor: "divider",
        bgcolor: "background.dark",
        "& .hg-theme-default": {
          bgcolor: "background.dark",
        },
        "& .hg-button": {
          bgcolor: "background.default",
          color: "text.primary",
          borderBottom: "1px solid",
          borderColor: "divider",
          "&:active, &:hover": {
            bgcolor: "primary.main",
            color: "common.white",
          },
        },
        "& .hg-row": {
          mb: 0,
        },
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "flex-end", px: 1, pt: 0.5 }}>
        <Button
          size="small"
          variant="contained"
          color="error"
          onClick={closeKeyboard}
          onTouchStart={closeKeyboard}
          sx={{ minWidth: "auto", fontSize: "0.75rem", marginBottom: "2px" }}
        >
          Close
        </Button>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
        <Keyboard
          keyboardRef={(r) => { keyboardRef.current = r; }}
          layoutName={layoutName}
          layout={{
            numeric: ["1 2 3", "4 5 6", "7 8 9", "{backspace} 0 . ,"],
            default: [
              "\u00A7 1 2 3 4 5 6 7 8 9 0 + \u00B4 {bksp}",
              "{tab} q w e r t y u i o p \u00E5 \u00A8",
              "{lock} a s d f g h j k l \u00F6 \u00E4 ' {enter}",
              "{shift} < z x c v b n m , . - {shift}",
              "@ {space}",
            ],
            shift: [
              '\u00B0 ! " # $ % & / ( ) = ? ` {bksp}',
              "{tab} Q W E R T Y U I O P \u00C5 ^",
              "{lock} A S D F G H J K L \u00D6 \u00C4 * {enter}",
              "{shift} > Z X C V B N M ; : _ {shift}",
              "@ {space}",
            ],
          }}
          onChange={onKeyboardChange}
          onKeyPress={onKeyPress}
        />
      </Box>
    </Box>
  );
};

export default Numpad;
